//
//
//
//

const allComponents = [] // 保存所有组件

export default {
  name: 'sort-order-table-th',
  components: {
  },
  props: {
    column: {
      required: true
    }
  },
  data () {
    return {
      sortType: '',
      params: {}
    }
  },
  created () {
    allComponents.push(this)
  },
  mounted () {
  },
  /**
   * Free up memory
   */
  beforeDestroy () {
    this.params = null
    for (let i = 0; i < allComponents.length; i++) {
      if (allComponents[i] === this) {
        allComponents.splice(i, 1)
        break
      }
    }
  },
  watch: {
  },
  computed: {
    classStr: function () {
      return this.sortType === '' ? 'sorting' : (this.sortType === 'ASC' ? 'sorting_asc' : 'sorting_desc')
    }
  },
  methods: {
    onSortOrder (...args) {
      for (let i = 0; i < allComponents.length; i++) {
        // 清楚所有组件的样式
        if (allComponents[i] === this) {
          continue
        }
        allComponents[i].sortType = ''
      }
      this.sortType = this.sortType === 'DESC' ? 'ASC' : 'DESC'
      this.params = {sortType: this.sortType, sortColumn: this.column}

      this.$emit('trigger', ...[this.params, ...args]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SortOrderTableTh.vue